module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 _.each(infos, function(info, i) { 
__p+='\n<span class="tag ';
 if ( info.closeable !== false ) print('clickable') 
__p+='" data-index="'+
((__t=( i ))==null?'':__t)+
'">\n	'+
((__t=( info.text ))==null?'':__t)+
'\n	';
 if ( info.closeable !== false ) { 
__p+='\n		<span>x</span>\n	';
 } 
__p+='\n</span>\n';
 }) 
__p+='\n';
}
return __p;
};


//////////////////
// WEBPACK FOOTER
// /Users/bm/app/code/jsapps/modules/reserva/templates/engine/filterinfo.html
// module id = 66
// module chunks = 0